export const formatGraphicVolumePerZones = (data) => {
  return {
    labels: data.map((el) => {
      return el.zoneName;
    }),
    datasets: [
      {
        label: "Volume por zona",
        data: data.map((vol) => {
          return vol.sumVolume;
        }),
        backgroundColor: ["green"],
        borderColor: ["blue"],
        borderWidth: 2,
      },
    ],
  };
};

export const formatGraphicVolumePerProduct = (data) => {
  return {
    labels: data.map((el) => {
      return el.nameCompetidor;
    }),
    datasets: [
      {
        label: "Volume por produto",
        data: data.map((vol) => {
          return vol.volumeTotalProductForCompetidor;
        }),
        backgroundColor: ["green"],
        borderColor: ["blue"],
        borderWidth: 2,
      },
    ],
  };
};

export const formatGraphicVolumePerCities = (data) => {
  return {
    labels: data.map((el) => {
      return el.cityName;
    }),
    datasets: [
      {
        label: "Volume por cidade",
        data: data.map((vol) => {
          return vol.sumVolume;
        }),
        backgroundColor: ["green"],
        borderColor: ["blue"],
        borderWidth: 2,
      },
    ],
  };
};

export const formatGraphicVolumePerCompany = (data) => {
  console.log(data);
  return {
    labels: data.map((el) => {
      return el.nameCompany;
    }),
    datasets: [
      {
        label: "Volume por empresa",
        data: data.map((company) => {
          return company.totalVolumeCompany;
        }),
        backgroundColor: ["green"],
        borderColor: ["blue"],
        borderWidth: 2,
      },
    ],
  };
};

export const formatGraphicVolumePerCovep = (data) => {
  return {
    labels: data.map((el) => {
      return el.cliente;
    }),
    datasets: [
      {
        label: "Volume perdido",
        data: data.map((cov) => {
          return cov.total;
        }),
        backgroundColor: ["green"],
        borderColor: ["blue"],
        borderWidth: 2,
      },
    ],
  };
};

export const formatGraphicVolumePerConcorrente = (data) => {
  console.log(data);
  return {
    labels: data.produtos.map((el) => {
      return el.produto;
    }),
    datasets: [
      {
        label: "Volume por produto",
        data: data.produtos.map((conc) => {
          return conc.total;
        }),
        backgroundColor: ["green"],
        borderColor: ["blue"],
        borderWidth: 2,
      },
    ],
  };
};

export const formatGraphicVolumePerUsuario = (data) => {
  console.log(data);
  return {
    labels: data.map((el) => {
      return `${el.nameCompetidor} - ${el.nameProduct}`;
    }),
    datasets: [
      {
        label: "Volume por usuário",
        data: data.map((conc) => {
          return conc.volumeTotalProductCompetidor;
        }),
        backgroundColor: ["green"],
        borderColor: ["blue"],
        borderWidth: 2,
      },
    ],
  };
};
